module.exports = __webpack_public_path__ + "static/media/retention-stat.a96f49ab.svg";